// extracted by mini-css-extract-plugin
var _1 = "RentalPortalOverviewApprovalRow-moduleavatar__MVVNV";
export { _1 as "avatar" }
